import React, {Fragment, useState, useEffect, useContext } from 'react';
import { SessionContext } from '../../context/sessionContext';
import { Table, Row, Col, Button} from "react-bootstrap";
import DatePicker from "react-datepicker";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import Modal from 'react-bootstrap/Modal';

import Select from 'react-select';
import SelectInput from "../selectInput";

import {optionsRP2_Todos, optionsPrograma, optionsEstado, optionsTipo, optionsTitular, optionsTramitacionVisado_Todos, optionsTramitacionVisado } from "../../datos/options";
import { escaparRegex } from "../../utils/escaparRegex";

import { toast } from "react-toastify";

const Select_5_Visado = ({openReporte_5_visado}) => {

	const { roleA, sesionT } = useContext(SessionContext);

	const url = `/api/api_serv/reportes/reporte5_Visado/`; //${baseURL}

	useEffect(() => {
		if (openReporte_5_visado === true && datosS === null) {
			console.log("VISADO es true?", openReporte_5_visado) //mover todo acá???	
			getDatos(url);	//console.log("_____________________LLAMANDO DATOS RESOLUCION");			
	
		} else if (openReporte_5_visado === false) {
			console.log("NO SE DIO CLICK - es false??", openReporte_5_visado)
		}
	},[openReporte_5_visado]); 

  	const name = roleA.username;

	const [datosS, setDatos] = useState(null);// ESTADO para recibir datos de la consulta

	//**31-08-2022 ABRE edicion desde reporte 5 visado_plano_t
	const onChange = (e) => {
		setEditRegistro({...editRegistro, [e.target.name] : e.target.value});
		setOriginal(1);
	}

	const handleFecha1 = (item) => {
		const fecha = item.value;
		//console.log("cambio DATE Fecha Reporte Visado");
		setEditRegistro({ ...editRegistro, [item.name]: fecha });
		setOriginal(1);
	}

	const [original, setOriginal] = useState(0); //estado original en 0; si cambia a uno habilitar el boton de guardar

	const [show, setShow] = useState(false);

	const handleClose = () => {
		setShow(false);
		setOriginal(0);
	};

	const [editRegistro, setEditRegistro] = useState({
		id_exp_pruebaE : "",
		t_137_tramitacion_visado_E : "",
    	fecha_visado_plano_t_E : "",
		t_139_fecha_entrega_E: "", //139 - ADD 20-09-2022
    	t_140_observaciones_tramitacion_E:"" //140 - ADD 20-09-2022
	});

	const {
		id_exp_pruebaE,
		t_137_tramitacion_visado_E,
	 	fecha_visado_plano_t_E,
		t_139_fecha_entrega_E,
		t_140_observaciones_tramitacion_E
	} = editRegistro;

	const guardarEditRegistro = async e => {
		e.preventDefault();

		try {
			const body = {
				editRegistro, name
			}

			const response = await fetch(
				`/api/authentication/reporteVisado_edit_expediente`, //${baseURL}
				{
				method: "POST",
				headers: {
					"Content-type": "application/json"
				},
				body: JSON.stringify(body)
				}
			);
			//console.log(response);
			const parseRes = await response.json();
			//console.log(parseRes);

			//EX 15-09-2026: el chequeo era `if (parseRes.expediente)`. Como el nro. de expediente es
			//opcional, con el campo vacio el string vacio es falsy: el modal quedaba ABIERTO aunque
			//el guardado hubiera sido correcto. Ahora se mira response.ok + id !== 'error'.
			if (response.ok && parseRes && parseRes.id !== 'error'){
				toast.success(parseRes.expediente
					? `Expediente ${parseRes.expediente} actualizado!!`
					: 'Expediente actualizado!!');
					setShow(false);
					getDatos(url);//30-08-2022: si hubo cambio, volver a llamar
			} else {
				//console.log("error");
				toast.error(parseRes && parseRes.message ? parseRes.message : 'Ocurrio un problema al actualizar el expediente');
			}

		} catch(err){
			console.error(err.message);
		}
	}

	//--- 31-08-2022 CIERRA edicion desde reporte 5 visado_plano_t

	const [filtro, setFiltro] = useState({ //PROBAR con 2 filtros
		t_137_tramitacion_visado:"",
		expediente:"",
		partido:0,
		nombre_proyecto:"",
		//fecha_envio_resol_t:"",
		//fecha_emision_prefac_h_t:"",
		numero_especial_resol_t:"",
		fecha_envio_resol_t:"",
	});
	const {t_137_tramitacion_visado, expediente, partido, nombre_proyecto, numero_especial_resol_t, fecha_envio_resol_t} = filtro;

	const [datosOriginal, setDatosOriginales] = useState(null);
	//console.log(datosOriginal);

	const [datosFiltrado, setDatosFiltrado] = useState(null);

	const [search, setSearch] = useState(""); //posible borrar
	const [searchPartido, setSearchPartido] = useState(0);
	//const [searchAlias, setSearchAlias] = useState("");
	const [searchEstado, setSearchEstado] = useState("");
	//console.log(searchEstado);
	const [searchPrograma, setSearchPrograma] = useState("");
	const [searchTipo, setSearchTipo] = useState("");
	//const [searchTitular, setSearchTitular] = useState("");

	//const [campoBusqueda, setCampoBusqueda] = useState([]);
	//console.log(campoBusqueda);

	const [arrayBusqueda, setArrayBusqueda]= useState({
		"tramitacion_visadoB" : "No",
		"partidoB" : 0,
		//"estadoB" : "",
		//"aliasB" : "",
		//"programaB" : "",
		//"tipoB" : "",
		//"titularB" : "",
	});
	//console.log(arrayBusqueda);

	//**SELECCIONAR campos tabla madre***

	const [municipioMadre, setMunicipioMadre] = useState("");

	const [datosMadre, setDatosMadre] = useState(null);

	//activo: true son los que mostraria inicialmente.
	const [camposInicial, setCamposInicial] = useState([
		{label:'Partido', activo:'true', campo:'partido_nombre'},
		{label:'Expediente', activo:'true', campo:'expediente'},
		{label:'Estado', activo:'false', campo:'estado'},
		{label:'Alias', activo:'true', campo:'nombre_proyecto'},
		{label:'Programa', activo:'false', campo:'programa'},
		{label:'Tipo', activo:'false', campo:'tipo'},
		{label:'Titular', activo:'false', campo:'titular_tierra'},
		{label:'Cantidad lotes', activo:'false', campo:'cantidad_lotes'},
		{label:'Lotes captados municipio', activo:'false', campo:'lotes_adquiridos_municipio'},
		{label:'Nomenclatura catastral', activo:'false', campo:'datos_18_sintesis_nomenclatura'},
	]);

	//const [columnasMadre, setColumnasMadre] = useState(["Partido", "Expediente", "Estado", "Alias", "Programa", "Tipo", "Titular", "Cantidad lotes", "Lotes captados municipio", "Nomenclatura catastral"]);
	//console.log(columnasMadre);

	//---campos tabla madre------
	//**04-05 --> Funciona pero NO USAR
	/*
	useEffect(()=>{
		//console.log("ARRAY de CAMPOS BUSQUEDA");
		//console.log(campoBusqueda);
	}, [campoBusqueda])
	*/


	//***TODO PARA SEARCH***********
	//****************************04-05***CADA VEZ que CAMBIA arrayBusqueda

	useEffect(()=>{
		//console.log("HACER BUSQUEDA CON MULTIPLES VARIABLES"); //sobre datos Originales

		if(datosS !== null){

			//const REGEX = /a|b/g;
			//const REGEX = /[0-59]/g;
			//console.log(REGEX);

			var rxPartido = /\d{1}/ ;
			//console.log(arrayBusqueda.partidoB);
			//console.log(typeof(arrayBusqueda.partidoB));

			var xF = parseInt(arrayBusqueda.partidoB);
			//console.log(typeof(xF));
			//console.log(`${xF}`);
			//console.log(xF);
			var zF = `${xF}`;

			//const regexPartido = new RegExp(arrayBusqueda.partidoB{2});
			const uno = /^d/;
			//console.log(uno);
			//const regexPartido = new RegExp(/^`${arrayBusqueda.partidoB}/);
			//const regexPartido = new RegExp(arrayBusqueda.partidoB); //  /^d/
			var regexPartido =  new RegExp(`^${escaparRegex(arrayBusqueda.partidoB)}{1,3}`); //   /^d{1,3}/ ;
			//let uno = new RegExp(`^${arrayBusqueda}{${nro}}`);


			if(xF === 0 ){
				regexPartido = /./;
			} else if(xF > 0 && xF < 10){
				//console.log("PARA Alsina");
				const arrayB1 = `${arrayBusqueda.partidoB}`;
				regexPartido = new RegExp(`^${escaparRegex(arrayB1)}{1,3}`);
			} else if(xF > 9 && xF < 99) {
				//console.log("PARA Benito Juarez");
				const arrayB2 = `${arrayBusqueda.partidoB}`;
				regexPartido =  new RegExp(`^${escaparRegex(arrayB2)}{1,3}`);
			} else {
				regexPartido = new RegExp(`^${escaparRegex(arrayBusqueda.partidoB)}{1,3}`);
			}
			//console.log(regexPartido);


			var regexTramitValidacion = new RegExp(`${escaparRegex(arrayBusqueda.tramitacion_visadoB)}$`, 'i');
			//console.log(regexTramitValidacion);

			/*const filtradoP = datosOriginal.filter((item, index) =>{

				//VERIFICAR solo donde sean iguales para evitar que tome por ejemplo 1 para (todos los que empiezan con 1)1, 11, 120....
				if(parseInt(arrayBusqueda.partidoB) ===0){
					//console.log("PARTIDO es VALUE CERO _____  DENTRO del primer IF");
					//console.log(regexPartido.test(item.partido));
					//console.log("--->Partido es cero");
					//console.log(regexTramitValidacion.test(item.t_137_tramitacion_visado));
					//console.log(/./.test(item.partido));

					if( item.t_137_tramitacion_visado!==null){ //TIENE UN VALOR
						//console.log("TRAMITACION TIENE VALOR ---- PARTIDO es TODOS");
						//console.log(regexTramitValidacion.test(item.t_137_tramitacion_visado));
						//console.log(/./.test(item.partido));
						return regexTramitValidacion.test(item.t_137_tramitacion_visado) && /./.test(item.partido)
					} else { //CON VALOR O SIN VALOR
						//console.log("MOSTRAR TODOS ---> tramitacion Visado");
						//console.log(item.t_137_tramitacion_visado);
						//console.log(/./.test(item.t_137_tramitacion_visado));
						return /./.test(item.t_137_tramitacion_visado) && /./.test(item.partido)
					}


				} else if(item.partido === parseInt(arrayBusqueda.partidoB) && item.t_137_tramitacion_visado ==="" ){

					//console.log("partido y array son iguales");
					//console.log(item.partido);
					if (regexTramitValidacion.test(item.t_137_tramitacion_visado)===true && regexPartido.test(item.partido) ===true){
						//console.log("___________________LOS DOS SON TRUE");
					}
					//console.log(parseInt(arrayBusqueda.partidoB));
					//console.log(regexPartido.test(item.partido));
					//console.log("UNO IF");


					if(item.t_137_tramitacion_visado ===""){
						//console.log("UNO");
						return /./.test(item.t_137_tramitacion_visado) && regexPartido.test(item.partido)
					} else {
						//console.log("DOS");
						return regexTramitValidacion.test(item.t_137_tramitacion_visado) && regexPartido.test(item.partido)
					}


				} else if(item.partido === parseInt(arrayBusqueda.partidoB) && item.t_137_tramitacion_visado !=="") {
					//console.log("DOS IF");
				}
			})
			//console.log(filtradoP);*/

			const filtradoP = datosOriginal.filter((item, index) =>{

				//VERIFICAR solo donde sean iguales para evitar que tome por ejemplo 1 para (todos los que empiezan con 1)1, 11, 120....
				if(parseInt(arrayBusqueda.partidoB) ===0){
					//console.log("PARTIDO es VALUE CERO _____  DENTRO del primer IF");
					//console.log(regexTramitValidacion.test(item.t_137_tramitacion_visado));
					//console.log(/./.test(item.partido));

					return  /./.test(item.partido) && regexTramitValidacion.test(item.t_137_tramitacion_visado)

				} else if(item.partido === parseInt(arrayBusqueda.partidoB)){

					//console.log("partido y array son iguales");
					//console.log(item.partido);
					//console.log(regexTramitValidacion.test(item.t_137_tramitacion_visado));
					//console.log(parseInt(arrayBusqueda.partidoB));
					//console.log(regexPartido.test(item.partido));

					return regexPartido.test(item.partido) && regexTramitValidacion.test(item.t_137_tramitacion_visado)

				}
			})
			//console.log(filtradoP);
			setDatos(filtradoP);
		}

	},[arrayBusqueda, datosOriginal]);


	//***Expediente***
	//https://bobbyhadz.com/blog/react-value-prop-on-input-should-not-be-null
	/* *** NO HACER FILTRADO POR EXPEDIENTE **** 04-06-2022
	const handleSearch = (e) => {
		//console.log("Search Expediente");

		//console.log(e.target.name);
		if(e.target.value !== null){
			//Con el nuevo setArrayBusquda, el que sigue no haria falta
    	setSearch(e.target.value); //HACE cambiar search---> ver el useEffect

			//4-05***Funciona, pero por ahora no usar, pensar utilidad
			var camposB = campoBusqueda.includes("expediente");
			if(!camposB){
				setCampoBusqueda([...campoBusqueda, "expediente"]);
			}
			setArrayBusqueda({...arrayBusqueda,  "expB":e.target.value} )
			//-------04-05:Funciona pero no usar, por ahora-----
		}
  };*/

	//***NO EJECUTAR
	/*
	useEffect(()=>{
		if(datosS !== null){
			//if(datosFiltrado !== null){
				//https://stackoverflow.com/questions/33347806/regex-through-array-of-objects
				const regex = new RegExp(search, 'i');
				//console.log(regex);

				const filterDatos = datosOriginal.filter((item) =>{ //**cambiar datosS x datosOriginal
					//var busqueda = item.estado;
					//item.expediente.includes(search)
					//item.expediente.match(new RegExp(search, "i")).map(name => {return <p>{name}</p>})
					//console.log(regex.test(item.expediente));
					return regex.test(item.expediente)
				});
				//console.log(filterDatos);
				//setDatos(filterDatos); //NO cambiar estado
				//setDatosFiltrado(filterDatos); // si guardo datos acá, para la busqueda de alias deberia buscar en datosFiltrados)
		}
	}, [search]);
	*/
	//---Expediente---

	//***Estado***
	/*
	const handleOnChangeEstado = (e) => {
		//console.log("CHANGE ESTADO");
		if(e.value){

			if(e.value !== null){
				setSearchEstado(e.value);
				setArrayBusqueda({...arrayBusqueda,  "estadoB":e.value} );
				setFiltro({...filtro,  "estado":e.value} );
			}
		} else if( e.value === ""){
			setSearchEstado(/./); //https://lenguajejs.com/javascript/caracteristicas/expresiones-regulares/
			setArrayBusqueda({...arrayBusqueda,  "estadoB":e.value} );
			setFiltro({...filtro,  "estado":e.target.value} )

		} else if (e.target.value){
			if(e.target.value !== null){
				setSearchEstado(e.target.value);
				setArrayBusqueda({...arrayBusqueda,  "estadoB":e.target.value} )
				setFiltro({...filtro,  "estado":e.target.value} )
			}
		} else {
			//console.log("____SELECCIONADO SIN VALOR");
			setSearchEstado(/./);
			setArrayBusqueda({...arrayBusqueda,  "estadoB":""} )
			setFiltro({...filtro,  "estado":""} )
		}
	}
	*/
	//---Estado---

	//***Partido***
	const handleOnChangePartido = (e) => {

		if(e.value){
			//console.log(e.value);

			if(e.value !== null){
				setSearchPartido(e.value);
				setArrayBusqueda({...arrayBusqueda,  "partidoB":e.value} )
				setFiltro({...filtro,  "partido":e.value} )
			}
		} else if( e.value === ""){
			setSearchPartido(/./); //https://lenguajejs.com/javascript/caracteristicas/expresiones-regulares/
			setArrayBusqueda({...arrayBusqueda,  "partidoB":e.value} )
			setFiltro({...filtro,  "partido":e.value} )

		} else if (e.target.value){
			//console.log(e.target);
			if(e.target.value !== null){
				//console.log("VALUE PARTIDO");
				//console.log(e.target.value);
				if(e.target.value === 0){
					setSearchPartido(e.target.value);
					setArrayBusqueda({...arrayBusqueda,  "partidoB":0} )
					setFiltro({...filtro,  "partido":0} )
				} else {
					setSearchPartido(e.target.value);
					setArrayBusqueda({...arrayBusqueda,  "partidoB":e.target.value} )
					setFiltro({...filtro,  "partido":e.target.value} )
				}

			}
		} else {
			setSearchPartido(/./);
			setArrayBusqueda({...arrayBusqueda,  "partidoB":0} )
			setFiltro({...filtro,  "partido":0} )
		}
	}
	//---Partido---

	//***Alias*** POR AHORA NO FILTRAR POR ALIAS 04-06-2022
	/*
	const handleSearchAlias = (e) => {
			if(e.target.value !== null){
	    	setSearchAlias(e.target.value); //NO se ejecuta el useEffect

				var camposB = campoBusqueda.includes("alias");

				if(!camposB){
					setCampoBusqueda([...campoBusqueda, "alias"]);
				}

				//***4-05
				setArrayBusqueda({...arrayBusqueda,  "aliasB":e.target.value} )
			}
	};*/

	/*
	useEffect(()=>{
		if(datosS !== null){

			if(datosFiltrado !== null){
				const regex = new RegExp(searchAlias, 'i');

				const filterDatos = datosFiltrado.filter((item) =>{ //**cambiar datosS x datosOriginal
					return regex.test(item.alias)
				});
				setDatos(filterDatos);
				setDatosFiltrado(filterDatos)
			} else {
				const regex = new RegExp(searchAlias, 'i');

				const filterDatos = datosOriginal.filter((item) =>{ //**cambiar datosS x datosOriginal
					return regex.test(item.alias)
				});
				//setDatos(filterDatos);
				//setDatosFiltrado(filterDatos)
			}

		}
	}, [searchAlias]);
	*/

	//--Alias---

	//***Programa*** //ver diferencia si usa <select> o <SelectInput>
	const handleOnChangePrograma = (e) => {

		if(e.value){

			if(e.value !== null){
				setSearchEstado(e.value);
				setArrayBusqueda({...arrayBusqueda,  "programaB":e.value} )
				setFiltro({...filtro,  "programa":e.value} )
			}
		} else if( e.value === ""){
			setSearchEstado(/./); //https://lenguajejs.com/javascript/caracteristicas/expresiones-regulares/
			setArrayBusqueda({...arrayBusqueda,  "programaB":e.value} )
			setFiltro({...filtro,  "programa":e.value} )

		} else if (e.target.value){
			if(e.target.value !== null){

				if(e.target.value === 0){
					setSearchPrograma(e.target.value);
					setArrayBusqueda({...arrayBusqueda,  "programaB":""} )
					setFiltro({...filtro,  "programa":""} )
				} else {
					setSearchPrograma(e.target.value);
					setArrayBusqueda({...arrayBusqueda,  "programaB":e.target.value} )
					setFiltro({...filtro,  "programa":e.target.value} )
				}
			}
		} else {
			setSearchEstado(/./);
			setArrayBusqueda({...arrayBusqueda,  "programaB":""} )
			setFiltro({...filtro,  "programa":""} )
		}
	} //---cierra handleOnChangePrograma -----

	/*
	useEffect(()=>{ //***** NO EJECUTAR
		if(datosS !== null){
			const regex = new RegExp(searchPrograma, 'i');

			const filterDatos = datosOriginal.filter((item)=>{
				return regex.test(item.programa);
			});
			setDatos(filterDatos);
		}
	}, [searchPrograma]);*/
	//---Programa---

	//***Tipo***
	const handleOnChangeTipo = (e) => {

		if(e.value){
			if(e.value !== null){
				setSearchTipo(e.value);
				setArrayBusqueda({...arrayBusqueda,  "tipoB":e.value} )
				setFiltro({...filtro,  "tipo":e.value} )
			}
		} else if( e.value === ""){
			setSearchTipo(/./); //https://lenguajejs.com/javascript/caracteristicas/expresiones-regulares/
			setArrayBusqueda({...arrayBusqueda,  "tipoB":e.value} )
			setFiltro({...filtro,  "tipo":e.value} )

		} else if (e.target.value){
			if(e.target.value !== null){

				if(e.target.value === 0){
					setSearchTipo(e.target.value);
					setArrayBusqueda({...arrayBusqueda,  "tipoB":""} )
					setFiltro({...filtro,  "tipo":""} )
				} else {
					setSearchTipo(e.target.value);
					setArrayBusqueda({...arrayBusqueda,  "tipoB":e.target.value} )
					setFiltro({...filtro,  "tipo":e.target.value} );
				}

			}
		} else {
			setSearchTipo(/./);
			setArrayBusqueda({...arrayBusqueda,  "tipoB":""} )
			setFiltro({...filtro,  "tipo":""} )
		}
	}


	//---Tipo---

	//***Tramitacion*** // 13-06-2022
	//tramitacion_visadoB
	const handleTramitacionVisado = (e) => {
		if(e.value){
			if(e.value !== null){
				//setSearchTitular(e.value);
				setArrayBusqueda({...arrayBusqueda,  "tramitacion_visadoB":e.value} )
			}
		} else if( e.value === ""){
			//setSearchTitular(/./); //https://lenguajejs.com/javascript/caracteristicas/expresiones-regulares/
			setArrayBusqueda({...arrayBusqueda,  "tramitacion_visadoB":e.value} )

		} else if (e.target.value){
			if(e.target.value !== null){
				//setSearchTitular(e.target.value);
				setArrayBusqueda({...arrayBusqueda,  "tramitacion_visadoB":e.target.value} )
			}
		} else {
			//setSearchTitular(/./);
			setArrayBusqueda({...arrayBusqueda,  "tramitacion_visadoB":""} )
		}
	}
	//---Titular---

	//**Hacer QUERY, mostrar tabla sintesis***
	/*
	const onchangeSelectMunicipio = (item) => {

		const filterMunicipio = item.value;
		setMunicipioMadre(filterMunicipio);

		var url = item.url;
		const urlM = `${baseURL}api/expediente/todos/?prioritario=${prioritario}&programa=${programa}&partido=${partido}&tipo=${tipo}&estado=${estado}&datos_05_responsable=${datos_05_responsable}`;
		//const urlM = `${baseURL}api/reportes/reporte2_municipios/?filterMunicipio=${filterMunicipio}`;
		getDatos(urlM);
	};*/

	//**consultar los datos para el reporte2
	const getDatos = async (urlM) => {

		const headers = { 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*', jwt_token: localStorage.token }

		const res = await fetch(urlM, { headers })
		.then(res => res.json())
		.then(res => {
			setDatos(res)
			setDatosOriginales(res)
		})
		//.then(res => setDatosOriginales(res))
		.catch(err => console.log(err));
	}

	const columnas = ["Tramitación visado","Expediente","Partido","Alias", "Nro Resolucion", "Fecha emisión", "Observaciones"];

	const getHeader = (columnas)=>{

			return columnas.map((columna, index) => {
				if(columna === "Tramitación visado"){
					return <th>
						{columna}
						{/*<SelectInput
							name="tramitacion_visado"
							options={ optionsTramitacionVisado_Todos }
							onChange={e=>handleTramitacionVisado(e)}
						/>*/}
					</th>
				} else if (columna === "Expediente"){
					//return <th key={index} > {columna}<input id="search" type="text" name="search" onChange={handleSearch} value={search || ''} /> </th>
					return <th> {columna} </th>
				} else if (columna === "Partido") {
					return <th>
						{columna}
					</th>
				/*} else if (columna === "Estado") {
					return <th key={index} >
						{columna}
						<SelectInput
							name="estado"
							options={optionsEstado}
							onChange={e => handleOnChangeEstado(e)}
						/>
					</th>*/
				} else if (columna === "Alias") {
					//return <th key={index} > {columna}<input id="searchA" type="text" name="alias" onChange={handleSearchAlias} value={searchAlias || ''} /> </th>
					return <th style={{ width:"100px"}}> {columna} </th>
				} else if (columna === "Programa") {
					return <th>
						{columna}
						<SelectInput
							name="programa"
							options={optionsPrograma}
							onChange={e => handleOnChangePrograma(e)}
						/>
					</th>
				} else if (columna === "Tipo") {
					return <th>
						{columna}
						<SelectInput
							name="tipo"
							options={optionsTipo}
							onChange={e => handleOnChangeTipo(e)}
						/>
					</th>
				} else {
					return <th>{columna}</th>
				}
			})
		//}
	}

	const getRowsData = (datosS)=> {
		//console.log("EJECUTAR AL INICIO -- REPORTE 5");
		if(datosS !== null){

			return datosS.map((registro, index )=> {

				var soloFechaEmision = "";

				if(registro.fecha_emision_resol_t !== null){
					
					let date = registro.fecha_emision_resol_t;
					let newFecha = new Date(date); // se quita .toLocaleString()
					newFecha.setMinutes(newFecha.getMinutes() + newFecha.getTimezoneOffset())
					
					let fecha = newFecha.toLocaleString().split(',')[0];

					//****PARA la tabla;
					soloFechaEmision = fecha;

				} else {
					let soloFechaEmision = "";
				}

				var soloFechaVisado = '';
				var dateEdicionVisado = '';

				if(registro.fecha_visado_plano_t !== null){

					let date = registro.fecha_visado_plano_t;
					let newFecha = new Date(date);
					newFecha.setMinutes(newFecha.getMinutes() + newFecha.getTimezoneOffset())

					let fecha = newFecha.toLocaleString().split(',')[0];
					//****NO VA A la tabla;
					soloFechaVisado = fecha;

					//***PARA el formulario de edicion
					dateEdicionVisado = new Date(date);
					dateEdicionVisado.setMinutes(dateEdicionVisado.getMinutes() + dateEdicionVisado.getTimezoneOffset())

				} else {
					var soloFechaVisado = '';
					var dateEdicionVisado = '';
				}

				var dateFechaEntrega = '';

				if(registro.t_139_fecha_entrega !== null){
					let date = registro.t_139_fecha_entrega;
					
					//****NO VA A la tabla;

					//***PARA el formulario de edicion
					dateFechaEntrega = new Date(date);
					dateFechaEntrega.setMinutes(dateFechaEntrega.getMinutes() + dateFechaEntrega.getTimezoneOffset())

				} else {
					var dateFechaEntrega = '';
				}


				var tramitacion_visado = registro.t_137_tramitacion_visado;
				var expediente = registro.expediente;
				var nombre_proyecto = registro.alias;//nombre_proyecto
				var nro_resolucion = registro.numero_especial_resol_t;
				var fecha_emision_r = soloFechaEmision; //registro.fecha_emision_resol_t; USADO para la tabla
				var t_140_observaciones_tramitacion = registro.t_140_observaciones_tramitacion;

				var rowClick = (e)=>{
					e.preventDefault();
					setShow(true);

					setEditRegistro({
						...editRegistro,
						id_exp_pruebaE: registro.id_exp_prueba,
						t_137_tramitacion_visado_E : tramitacion_visado,
						fecha_visado_plano_t_E : dateEdicionVisado,
						t_139_fecha_entrega_E: dateFechaEntrega,
						t_140_observaciones_tramitacion_E : t_140_observaciones_tramitacion
					});

				}

				return <tr id={index} onDoubleClick={rowClick}>
					<td>{tramitacion_visado}</td>
					<td>{expediente}</td>
					<td>{registro.partido_nombre}</td>
					<td>{nombre_proyecto}</td>
					<td>{nro_resolucion}</td>
					<td>{fecha_emision_r}</td>
					<td>{t_140_observaciones_tramitacion}</td>
				</tr>;
			})
		}
	}

	if (datosS === null) {

		return(
			<Fragment>
				<p>INICIO hacer consulta</p>
				<div id="tabla_TODO" style={{ padding:"2px", width:"100%" }} className="">
					<div className="" style={{ width:"100%",  overflow:"scroll"}} >

						<Table stripped bordered hover responsive="md" >
							<thead >
								<tr style={{backgroundColor:"rgb(0,174,195)", color:"white"}}>{getHeader(columnas)}</tr>
							</thead>
							<tbody>
								{ getRowsData(datosS) }
							</tbody>
						</Table>

					</div>
				</div>

			</Fragment>
		)
	} else {
		//console.log("YA NO ES NULL");
		return (
			<Fragment>
				<br/>

				<div className="" style={{ width:"100%" }}> {/*, border:"2px solid #333" */}
					<div>
						<ReactHTMLTableToExcel
							//id="uno-table-xls-button"
							className="btn btn-info text_button"
							table="visado-to-xls"
							filename="tramitaciones_visado"
							sheet="tablexls"
							buttonText="Descargar XLS"
						/>
					</div>
					{/*`buscar: Partido:{partido || '____'}--Estado:{estado  || '____'} -- priorit:{prioritario  || '____'}-- Programa:{programa || '____'}--  Tipo:{tipo  || '____'}-- `*/}
				</div>{/*cierra div A*/}

				<div id="tabla_TODO" style={{ padding:"2px", width:"100%" }} className=""> {/*, border:"2px solid blue" */}
					<div className="" style={{overflow:"scroll"}} >{/* width:"100%",  border:"2px solid red",*/}

						<div className="container_left">

							<div className="input-container" style={{width: "25%"}}>
								<SelectInput
									name="partido"
									id="id_partido"
									options={ optionsRP2_Todos }
									onChange={e=>handleOnChangePartido(e)}
								/>
								<label alt="Partido" for="id_partido">Partido</label>
							</div>
							<div className="input-container" style={{width: "1%"}} />
							<div className="input-container" style={{width: "25%"}}>
								<SelectInput
									name="tramitacion_visado"
									id="id_tramitacion_visado"
									options={ optionsTramitacionVisado_Todos }
									onChange={e=>handleTramitacionVisado(e)}
								/>
								<label alt="Tramitación visado" for="id_tramitacion_visado">Tramitación visado</label>
							</div>

						</div>{/*cierra container_left*/}

						<Table className="tableExp" id="visado-to-xls" stripped bordered hover responsive="md" >
							<thead >
								<tr style={{backgroundColor:"rgb(0,174,195)", color:"white"}}>{getHeader(columnas)}</tr>
							</thead>
							<tbody>
								{ getRowsData(datosS) }
							</tbody>
						</Table>

						<Modal
							id="id_modal_1"
							show={show}
							onHide={handleClose}
							backdrop="static"
							keyboard={false}
							className="id_modal_1"
							style={{top: "200"}}
						>
							<Modal.Header style={{background: "rgb(0,174,195)", color:"white"}} closeButton>
								<Modal.Title>Edición{/*id_exp_pruebaE*/}</Modal.Title>
							</Modal.Header>
							<Modal.Body>

								<div className="container_left">
									<h6 className="mt-4 text-left subtitulos">VISADO DE PLANO - HÁBITAT</h6>
								</div>

								<div className="container_left" >
									<div className="input-container">
										<SelectInput
											name="t_137_tramitacion_visado_E"
											id="id_t_137_tramitacion_visado_E"
											defaultValue = {t_137_tramitacion_visado_E}
											onChange={e => onChange(e)}
											options={optionsTramitacionVisado}
											//className="form-control my-3"
										/>
										<label alt="Tramitación Visado" for="id_t_137_tramitacion_visado_E">Tramitación visado</label>
									</div>
								</div>{/*cierra ---> container_left */}

								<div className="container_left">
									<div className="input-container">
										<DatePicker
											placeholder="Fecha de visado" title="Fecha de visado"
											name="fecha_visado_plano_t_E"
											id="id_fecha_visado_plano_t_E"
											dateFormat="dd/MM/yyyy"
											className="form-control"
											selected={fecha_visado_plano_t_E}
											//onChange={handleFecha3}
											onChange={ (date) => handleFecha1({ name: "fecha_visado_plano_t_E", value: date })}
											//placeholderText="Fecha de visado"
										/>
										<label alt="Fecha de visado" for="id_fecha_visado_plano_t_E">Fecha de visado</label>
									</div>
								</div>{/*cierra ---> container_left */}

								<div className="container_left">
									<div className="input-container">
										<DatePicker
											placeholder="Fecha de entrega" title="Fecha de entrega"
											name="t_139_fecha_entrega_E"
											id="id_t_139_fecha_entrega_E"
											dateFormat="dd/MM/yyyy"
											className="form-control"
											selected={t_139_fecha_entrega_E}
											onChange={ (date) => handleFecha1({ name: "t_139_fecha_entrega_E", value: date })}
										/>
										<label alt="Fecha de entrega" for="id_t_139_fecha_entrega_E">Fecha de entrega</label>
									</div>
								</div>{/*cierra ---> container_left */}

								<div className="container_left" style={{ height: "auto"}}>
									<div className="input-container">
										<textarea
											title="Observaciones tramitación visado"
											type="text"
											id="id_t_140_observaciones_tramitacion_E"
											maxLength="2000"
											value={t_140_observaciones_tramitacion_E}
											name="t_140_observaciones_tramitacion_E"
											onChange={e => onChange(e)}
										/>
										<label alt="Observaciones tramitación visado" for="id_t_140_observaciones_tramitacion_E">Observaciones tramitación visado</label>
										{/*<p align="right" style={{ fontSize: "0.9em"}}>Caracteres restantes: {maxObservaciones_140}</p>*/}
									</div>
								</div>{/* cierra ---> container_left */}


							</Modal.Body>
							<Modal.Footer>
								<Button className="btn btn-success btn-block button_verde" onClick={guardarEditRegistro} disabled={original ===0 ? true : false }>	Guardar </Button>{/*guardarEditRegistro*/}
								<Button className="btn btn-success btn-block button_verde" onClick={handleClose}> Cancelar </Button>
							</Modal.Footer>
						</Modal>

					</div>
				</div>

			</Fragment>
		);
	}
}

export default Select_5_Visado;
//{datosS.filter(item => item.expediente.match(new RegExp("AD", "i")).map(filteredPerson => (
